import { render, staticRenderFns } from "./BottomSheetUserSettings.vue?vue&type=template&id=ff055986&scoped=true&"
import script from "./BottomSheetUserSettings.vue?vue&type=script&lang=js&"
export * from "./BottomSheetUserSettings.vue?vue&type=script&lang=js&"
import style0 from "./BottomSheetUserSettings.vue?vue&type=style&index=0&id=ff055986&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff055986",
  null
  
)

export default component.exports